module.exports = __webpack_public_path__ + "static/img/weui_toux.413bfa7.png";